import type { CategoryAttributeField, CategoryAttributeSalesSpec, CategoryAttributeSchemaView, CategoryAttributeReleaseView, CategoryAttributeCatalogListView } from "@control-plane/contracts";

export type AttributeVersion = CategoryAttributeSchemaView;
export type AttributeRelease = CategoryAttributeReleaseView;
export type AttributeCatalog = CategoryAttributeCatalogListView;

export function latestRelease(releases: AttributeRelease[], path: string) {
  // The server returns the append-only release sequence newest first.
  return releases.find(release => release.categoryPath === path);
}

export function salesSpecOptionsFromText(text: string, previous: CategoryAttributeSalesSpec["options"] = []) {
  return text.split("\n").map(label => label.trim()).filter(Boolean).map(label => ({
    label,
    value: previous.find(option => option.label === label)?.value ?? label,
  }));
}

export function validateAttributeDraft(path: string, fields: CategoryAttributeField[], salesSpecs: CategoryAttributeSalesSpec[] = []): string | null {
  if (path.split(" > ").length < 2) return "请先选择完整类目。";
  if (!fields.length && !salesSpecs.length) return "请至少添加一项商品属性或销售规格。";
  if (fields.length > 200) return "每个类目最多设置 200 项属性。";
  if (salesSpecs.length > 100) return "每个类目最多设置 100 项销售规格。";
  const ids = new Set<string>();
  for (const field of fields) {
    if (!field.name.trim()) return "请填写每项属性的名称。";
    if (ids.has(field.id)) return "属性重复，请重新添加。";
    ids.add(field.id);
    if (field.type === "single" || field.type === "multi") {
      if (!field.options?.length) return `请为“${field.name}”添加可选值。`;
      if (field.options.some(option => !option.label.trim() || !option.value.trim())) return `请补全“${field.name}”的可选值。`;
      if (new Set(field.options.map(option => option.value)).size !== field.options.length) return `“${field.name}”的可选值不能重复。`;
    }
  }
  const specIds = new Set<string>();
  const specNames = new Set<string>();
  for (const spec of salesSpecs) {
    const name = spec.name.trim();
    if (!name) return "请填写每项销售规格的名称。";
    if (specIds.has(spec.id)) return "销售规格重复，请重新添加。";
    if (specNames.has(name)) return `销售规格“${name}”重复，请修改名称。`;
    specIds.add(spec.id);
    specNames.add(name);
    if (!spec.allowCustomValues && !spec.options.length) return `请为“${name}”添加预设选项，或开启允许自定义。`;
    if (spec.options.some(option => !option.label.trim() || !option.value.trim())) return `请补全“${name}”的预设选项。`;
    if (new Set(spec.options.map(option => option.value)).size !== spec.options.length) return `“${name}”的预设选项不能重复。`;
  }
  return null;
}
